import * as S from './styles'
import { RadioButtonProps } from './types'

const RadioButton = ({
  id,
  onChange,
  name,
  value,
  checked,
  label,
}: RadioButtonProps) => {
  return (
    <S.RadioButtonLabel key={id} htmlFor={id}>
      <S.RadioButtonLabelInput
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      <S.CustomRadioButton>
        <S.CustomRadioButtonInner
          data-testid="radio-button-inner"
          checked={checked}
        />
      </S.CustomRadioButton>
      <S.CustomRadioLabelText>{label}</S.CustomRadioLabelText>
    </S.RadioButtonLabel>
  )
}

export default RadioButton
